import { render, staticRenderFns } from "./PagePagination.vue?vue&type=template&id=242972e8&scoped=true"
import script from "./PagePagination.vue?vue&type=script&lang=js"
export * from "./PagePagination.vue?vue&type=script&lang=js"
import style0 from "./PagePagination.vue?vue&type=style&index=0&id=242972e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242972e8",
  null
  
)

export default component.exports